import logEvent from 'analytics/logEvent';
import useTranslationAndTypograph from 'hooks/useTranslationAndTypograph';
import React from 'react';
import { useSelector } from 'react-redux';
import Image from 'next/image';

import ALink from 'components/basic/ALink';
import { H1 } from 'components/basic/Typography';
import AuthFormWrapper from 'components/basic/AuthFormWrapper';
import { Modal, useModal } from 'components/complex/Modal';
import AuthForm from 'components/complex/forms/AuthForm';

import type { AppState } from 'redux-store';
import { useAppDispatch } from 'redux-store';
import { openModal } from 'redux-store/slices/ui';

import styles from './styles.module.scss';

export const AuthModal: React.FC = () => {
  const t = useTranslationAndTypograph();
  const dispatch = useAppDispatch();
  const { redirectUrl: redirectUrlState } = useSelector(
    (state: AppState) => state.ui,
  );
  const { modalProps } = useModal({
    type: 'Auth',
    width: '800px',
    className: styles.authModalWrapper,
    background: (
      <>
        <div className={styles.bg}>
          <Image
            src="/pagesImages/auth-reg/auth-bg.png"
            width={800}
            height={704}
            layout="fill"
            objectFit="cover"
          />
        </div>
        <div className={styles.bgMobile}>
          <Image
            src="/pagesImages/auth-reg/auth-bg_mobile.png"
            width={375}
            height={812}
            layout="fill"
            objectFit="cover"
          />
        </div>
      </>
    ),
    title: t('Log into your account'),
    onAfterOpen: () => {
      logEvent('Web_Sign-in_Page_Viewed', {
        search: window.location.search || null
      });
    },
    subtitle: (
      <>
        {t('or')}{' '}
        <ALink
          onClick={(): void => {
            dispatch(
              openModal({
                type: 'Registration',
                redirectUrl: redirectUrlState || window.location.href,
              }),
            );
          }}
        >
          {t('create a new account')}
        </ALink>
      </>
    ),
  });

  let redirectUrl = '';

  if (typeof window !== 'undefined') {
    redirectUrl = modalProps.redirectUrl || window.location.href;
  }

  return (
    <Modal {...modalProps}>
      <AuthFormWrapper withoutTopPadding>
        <AuthForm redirectUrl={redirectUrl} />
      </AuthFormWrapper>
    </Modal>
  );
};
